export default class LanguagePicker {
    constructor($el) {
        this.$el = $el;
        this.trigger = this.$el.querySelector('[data-language-picker-trigger]');
        this.menu = this.$el.querySelector('[data-language-picker-menu]');
        this.mouseOver = false;
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        // this.goToLink = this.goToLink.bind(this);

        this.trigger.addEventListener('mouseover', this.showModal);
        this.trigger.addEventListener('click', this.toggleModal);

        this.menu.addEventListener('mouseover', (e) => {
            this.mouseOver = true;
        })

        this.menu.addEventListener('mouseleave', (e) => {
            this.mouseOver = false;
            this.closeModal();
        });

        this.trigger.addEventListener('mouseleave', (e) => {
            setTimeout(this.closeModal, 300);
        });
    }

    showModal(e) {
        e.preventDefault();
        this.menu.classList.add('language-picker__menu--open');
    }

    closeModal() {
        if( ! this.mouseOver) {
            this.menu.classList.remove('language-picker__menu--open');
        }
    }

    toggleModal(e) {
        if( ! this.menu.classList.contains('language-picker__menu--open')) {
            this.menu.classList.add('language-picker__menu--open');
            return;
        }
        this.menu.classList.remove('language-picker__menu--open');
    }
}